export default "__VITE_ASSET__44f83554__"